export default "__VITE_ASSET__DLELM3$i__"